"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoAgrupado = void 0;
var bson_1 = require("bson");
var NoAgrupado = /** @class */ (function () {
    function NoAgrupado(_a) {
        var _b = _a._id, _id = _b === void 0 ? new bson_1.ObjectId() : _b, _c = _a.index, index = _c === void 0 ? 0 : _c, _d = _a.tipo, tipo = _d === void 0 ? 0 : _d, _e = _a.item, item = _e === void 0 ? '' : _e, _f = _a.nos, nos = _f === void 0 ? new Array() : _f;
        this._id = _id;
        this.index = index;
        this.tipo = tipo;
        this.item = item;
        this.nos = nos;
    }
    return NoAgrupado;
}());
exports.NoAgrupado = NoAgrupado;
//# sourceMappingURL=NoAgrupado.js.map